import api from './../libs/api';

export default {

  trackTime: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/track-time`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getEveryTrackTime: async (startDate, endDate) => {
    try {
      // Only add params if both dates are provided
      if (startDate && endDate) {
        const params = new URLSearchParams();
        params.append('start_date', startDate);
        params.append('end_date', endDate);
        const response = await api().get(`/analytics/every-time-spent?${params.toString()}`);
        return response.data || [];
      }
      
      // If no dates, make request without params
      const response = await api().get('/analytics/every-time-spent');
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },

  getTotalTrackTime: async (startDate, endDate) => {
    try {
      // Only add params if both dates are provided
      if (startDate && endDate) {
        const params = new URLSearchParams();
        params.append('start_date', startDate);
        params.append('end_date', endDate);
        const response = await api().get(`/analytics/total-time-spent?${params.toString()}`);
        return response.data || [];
      }
      
      // If no dates, make request without params
      const response = await api().get('/analytics/total-time-spent');
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },

}; 